var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('div',{staticClass:"header-date",class:{
    weekend: _vm.date.isoWeekday() === 6 || _vm.date.isoWeekday() === 7,
    today: _vm.date.dayOfYear() === _vm.today.dayOfYear(),
  }},[_c('div',{staticClass:"today-top"}),_c('div',{staticClass:"top"},[_vm._v(_vm._s(_vm.date.format("dd").toUpperCase()))]),_c('div',{staticClass:"bottom"},[_vm._v(_vm._s(_vm.date.date()))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }